import { useCallback } from 'react';
import { useObservation } from 'apps/sigma2-ui/src/state/observation';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { getMetricByColumnHeaderValueFromObservation } from 'libs/end-to-end/src/me';

export const useGetColumnDisplayName = (): {
  getColumnDisplayName: (columnName: string) => string;
} => {
  const { myObservation } = useObservation();
  const language = useLanguage();

  const getColumnDisplayName = useCallback(
    (columnName: string) => {
      if (!myObservation) {
        return columnName;
      }

      // check if column name is a dimension
      const dimension = myObservation.dimensions.find(
        (dim) => dim.columnHeaderValue === columnName,
      );

      if (dimension) {
        return language.dimensionDisplayName({
          definition: dimension,
        });
      }

      // check if column name is a metric
      const metricInfo = getMetricByColumnHeaderValueFromObservation({
        columnHeaderValue: columnName,
        myObservation,
      });

      if (metricInfo) {
        return language.metricDisplayName({
          definition: metricInfo,
        });
      }

      // if not found, return the column name as is
      return columnName;
    },
    [myObservation, language],
  );

  return { getColumnDisplayName };
};
